
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { queryPoInfoDocAndNumbers } from "@/api/customs-packing";
import { CustomsPackingItem } from "./configContainerTypeModels";

type VarianceMark = "over" | "short";

interface PoInfoNumber {
  typeName?: string;
  refNumber?: string;
}

interface PoInfoDoc {
  poInfoId?: string;
  hqTransactionNumber?: string;
  description?: string;
  declarationDescription?: string;
  quantity?: number;
  poCode?: string;
  piCode?: string;
  /** null 无超欠发或已处理，true 超发，false 欠发 */
  overDelivery?: boolean | null;
  numbers?: PoInfoNumber[];
}

@Component({
  name: "ConfigContainerPackingDetailDrawer",
})
export default class ConfigContainerPackingDetailDrawer extends Vue {
  @Prop({ type: Boolean, default: false }) private visible!: boolean;
  @Prop({ type: String, default: "" }) private packingListCode!: string;
  @Prop({ required: false, default: null })
  private packing!: CustomsPackingItem | null;

  private lines: PoInfoDoc[] = [];
  private linesLoading = false;
  private loadSeq = 0;

  @Watch("visible")
  private onVisible(visible: boolean) {
    if (!visible) {
      this.loadSeq += 1;
      this.lines = [];
      this.linesLoading = false;
      return;
    }
    this.loadLines();
  }

  @Watch("packing")
  private onPackingChange() {
    if (this.visible) {
      this.loadLines();
    }
  }

  /** 主包装超/欠，来自 overUnderageStatus。ALL 时两者都展示。 */
  private get headerMarks(): VarianceMark[] {
    const status = this.packing && this.packing.overUnderageStatus;
    if (status === "OVERDELIVERY") {
      return ["over"];
    }
    if (status === "UNDERDELIVERY") {
      return ["short"];
    }
    if (status === "ALL") {
      return ["over", "short"];
    }
    return [];
  }

  private async loadLines() {
    const id = this.packing && this.packing.id;
    if (!this.visible || !id) {
      this.lines = [];
      return;
    }
    const seq = ++this.loadSeq;
    this.linesLoading = true;
    try {
      const data: any = await queryPoInfoDocAndNumbers(id);
      if (seq !== this.loadSeq) {
        return;
      }
      this.lines = Array.isArray(data) ? data : [];
    } catch (err) {
      if (seq !== this.loadSeq) {
        return;
      }
      this.lines = [];
    } finally {
      if (seq === this.loadSeq) {
        this.linesLoading = false;
      }
    }
  }

  private get packingCode(): string {
    const code = String((this.packing && this.packing.code) || "")
      .split("\n")[0]
      .trim();
    return code || "-";
  }

  private displayValue(
    value: string | number | null | undefined
  ): string {
    if (value === undefined || value === null || String(value).trim() === "") {
      return "-";
    }
    return String(value);
  }

  private get summaryToneClass(): string {
    const hasOver = this.headerMarks.indexOf("over") !== -1;
    const hasShort = this.headerMarks.indexOf("short") !== -1;
    if (hasOver && hasShort) {
      return "is-mixed";
    }
    if (hasOver) {
      return "is-over";
    }
    if (hasShort) {
      return "is-short";
    }
    return "";
  }

  private markLabel(mark: VarianceMark): string {
    return mark === "over" ? "超" : "欠";
  }

  private onVisibleChange(value: boolean) {
    this.$emit("update:visible", value);
  }

  private close() {
    this.$emit("update:visible", false);
  }
}
